/*
 * @Author: Chao Yang
 * @Date: 2019-12-23 15:42:43
 * @LastEditor: Chao Yang
 * @LastEditTime : 2019-12-24 17:42:07
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdMultipleDropdownComponent } from './ad-multiple-dropdown.component';

@NgModule({
  declarations: [AdMultipleDropdownComponent],
  imports: [CommonModule],
  exports: [AdMultipleDropdownComponent]
})
export class AdMultipleDropdownModule {}
export { AdMultipleDropdownComponent };
